import { getFilledInstrumentExperiences } from "./instrumentExperience";
import { formatProfilePreferredStyles } from "./profilePreferredStyles";

export const extractPrimaryInstrument = (profile = {}) => {
  if (!profile || !profile.instrumentExperience) {
    return null;
  }

  const experiences = getFilledInstrumentExperiences(profile.instrumentExperience);
  return experiences.length > 0 ? experiences[0] : null;
};

export const resolvePreferredStyle = (profile = {}) => {
  const preferredStyle = formatProfilePreferredStyles(profile);
  return preferredStyle || null;
};

export const buildFriendCardProfileContext = (profile = {}) => {
  const primaryInstrument = extractPrimaryInstrument(profile);
  const preferredStyle = resolvePreferredStyle(profile);
  const identityMetaLines = [
    primaryInstrument?.instrument || null,
    preferredStyle,
  ].filter(Boolean);

  return {
    primaryInstrument,
    preferredStyle,
    identityMetaLines,
  };
};

export const buildFriendPresenceStatus = (presence) => {
  if (!presence) {
    return null;
  }

  return {
    online: Boolean(presence.online),
    lastSeen: presence.lastSeen || null,
    placement: "br",
    size: "16px",
    offset: "2px",
    border: "2px solid rgba(10, 16, 28, 0.9)",
  };
};
